import React, { useEffect, useRef } from 'react';
import './Modal.css';

function Modal({ isOpen, onClose, title, children }) {
  const modalContentRef = useRef(null);
  const mouseDownTargetRef = useRef(null);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  // Handle mouse down to track where the click started
  const handleOverlayMouseDown = (e) => {
    // Only track if click started on the overlay itself, not on modal content
    if (e.target === e.currentTarget) {
      mouseDownTargetRef.current = e.target;
    } else {
      mouseDownTargetRef.current = null;
    }
  };

  // Handle click - only close if click started and ended on overlay
  const handleOverlayClick = (e) => {
    // Only close if the click started on the overlay and ended on the overlay
    if (mouseDownTargetRef.current === e.currentTarget && e.target === e.currentTarget) {
      onClose();
    }
    mouseDownTargetRef.current = null;
  };

  if (!isOpen) return null;

  return (
    <div 
      className="modal-overlay" 
      onClick={handleOverlayClick}
      onMouseDown={handleOverlayMouseDown}
    >
      <div 
        className="modal-content" 
        ref={modalContentRef}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;

